import { compressToBase64, decompressFromBase64 } from 'lz-string'
import store from 'store'

export const keys = {
  LatestCategory: 'latestCategory',
  PwaState: 'pwaState',
  AuthToken: 'authToken',
  AuthTokenRefreshTimeoutId: 'authTokenRefreshTimeoutId',
  CartToken: 'cartToken',
  ExtraHeaders: 'extraHeaders',
  User: 'user',
  ComparisonProducts: 'comparisonProducts',
  PaypalExpressState: 'paypalExpressState',
  StoreView: 'storeView'
} as const

export type Keys = typeof keys[keyof typeof keys]

const keysKeep: Keys[] = [
  'authToken',
  'authTokenRefreshTimeoutId',
  'cartToken',
  'latestCategory',
  'comparisonProducts',
  'storeView'
]

export const localStorage = {
  get: (key: Keys): any | undefined => {
    const data = decompressFromBase64(store.get(key))
    const value = data ? JSON.parse(data) : undefined
    return value
  },

  set: (key: Keys, value: any): void => {
    try {
      store.set(key, compressToBase64(JSON.stringify(value)))
    } catch {
      try {
        Object.keys(window.localStorage).forEach(key => {
          if (keysKeep.includes(key as Keys)) {
            return
          }

          delete window.localStorage[key]
          store.remove(key)

          // eslint-disable-next-line no-console
          console.log('Purged:', key)
        })
      } catch {
        // Crazy, hu?
      }
    }
  },

  remove: (key: Keys): void => {
    return store.remove(key)
  }
}
